import React, { useState } from "react";
import "./Tokenomics.scss";
import Button from "../../components/shared/Button";

import TokenomicsImg1 from "../../assets/images/tokenomics-1.png";
import TokenomicsImg2 from "../../assets/images/tokenomics-2.png";

import TotalSupplyIcon from "../../assets/images/total-supply-icon.svg";
import TransactionFeeIcon from "../../assets/images/transaction-fee-icon.svg";

import GridImg from "../../assets/images/hex-grid.png";

import { Waypoint } from "react-waypoint";
import CountUp from "react-countup";

export default function Roadmap() {
	// State to track if the waypoint has been passed
	const [startCounting, setStartCounting] = useState(false);

	return (
		<>
			<div className="tokenomics" id="tokenomics">
				<div className="decoration tokenomics-light-1"></div>
				<img
					className="decoration tokenomics-grid-bg"
					src={GridImg}
					alt="Grid"
				/>
				<div
					className="decoration tokenomics-img-1"
					data-aos="fade-right"
				>
					<img
						className="shake-slow-6"
						src={TokenomicsImg1}
						alt="Coin"
					/>
				</div>

				<div
					className="decoration tokenomics-img-2"
					data-aos="fade-left"
				>
					<img
						className="shake-slow-7"
						src={TokenomicsImg2}
						alt="Coin"
					/>
				</div>

				<div className="tokenomics-content-wrapper content-wrapper-lg">
					<h3 className="tokenomics-small-title" data-aos="fade-up">
						Tokenomics
					</h3>
					<h2
						className="tokenomics-title"
						data-aos="fade-up"
						data-aos-delay="50"
					>
						$AUR Token
					</h2>

					<Waypoint onEnter={() => setStartCounting(true)} />
					<div className="tokenomics-card">
						<div className="decoration gradient-bg"></div>
						<div className="decoration noise-bg"></div>

						<div className="tokenomics-info">
							<ul className="tokenomics-info-items">
								<li className="tokenomics-info-item">
									<div className="info-title">
										<img
											className="info-title-icon"
											src={TotalSupplyIcon}
											alt="Total Supply"
										/>
										Total Supply:
									</div>
									<div className="info-value">
										<CountUp
											start={99900000}
											end={startCounting ? 100000000 : 0}
											duration={5}
										/>{" "}
										$AUR Tokens
									</div>
								</li>
								<li className="tokenomics-info-item">
									<div className="info-title">
										<img
											className="info-title-icon"
											src={TransactionFeeIcon}
											alt="Transaction Fee"
										/>
										Transaction Fee:
									</div>
									<div className="info-value">
										<CountUp
											start={20}
											end={startCounting ? 5 : 20}
											duration={5}
										/>
										% Buy/Sell
									</div>
								</li>
							</ul>
						</div>

						<div className="tokenomics-btn">
							<Button
								className="details-btn"
								href="https://aur-ai.gitbook.io/aurai/tokenomics/distribution"
							>
								View Details
							</Button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
